import styled from 'styled-components'

import { BodyS } from '~ui'

export const Label = styled(BodyS)`
  color: ${({ theme }) => theme.colors.secondary};
  display: block;
  margin-bottom: 5px;
`
